var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEventsManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 2.5H16.375C17.5486 2.5 18.5 3.45139 18.5 4.625V17.375C18.5 18.5486 17.5486 19.5 16.375 19.5H3.625C2.4514 19.5 1.5 18.5486 1.5 17.375V4.625C1.5 3.4514 2.45139 2.5 3.625 2.5Z",
    stroke: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53362 6.37415C8.97982 4.93261 11.0202 4.93261 11.4664 6.37415V6.37415C11.7036 7.14041 12.4908 7.59487 13.2729 7.41714V7.41714C14.7445 7.08279 15.7647 8.84985 14.7394 9.95703V9.95703C14.1943 10.5456 14.1943 11.4545 14.7394 12.043V12.043C15.7647 13.1502 14.7445 14.9173 13.2729 14.5829V14.5829C12.4908 14.4052 11.7036 14.8596 11.4664 15.6259V15.6259C11.0202 17.0674 8.97982 17.0674 8.53362 15.6259V15.6259C8.29644 14.8596 7.50929 14.4052 6.7271 14.5829V14.5829C5.2556 14.9173 4.23539 13.1502 5.2607 12.043V12.043C5.80571 11.4545 5.80571 10.5456 5.2607 9.95703V9.95703C4.23539 8.84985 5.2556 7.08279 6.7271 7.41714V7.41714C7.50929 7.59487 8.29644 7.14041 8.53362 6.37415V6.37415Z",
    stroke: "#0D0D0D",
    strokeWidth: 0.923077
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99994,
    cy: 11.0003,
    r: 2.23224,
    stroke: "#0D0D0D",
    strokeWidth: 0.923077
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.610352L5 4.61035",
    stroke: "#0D0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.610352L15 4.61035",
    stroke: "#0D0D0D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEventsManager);
export default __webpack_public_path__ + "static/media/icon-events-manager.8b40cd68211d16ca2377897bf9eafc7d.svg";
export { ForwardRef as ReactComponent };